import type { SvgIconProps } from './types';

export function CloseIcon(props: SvgIconProps) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <path fill="none" stroke="currentColor" strokeWidth="2" d="M7,7 L17,17 M7,17 L17,7" />
    </svg>
  );
}
